export const ROUTES = {
  home: '/',
  form: '/form',
  history: '/history',
  anyLink: '*',
}
